import MainPanel from '~/js/components/wedding-styler/wishlist-collage/MainPanel';

const internals = {};

internals.filterCollageDataByEvent = (collageData, eventType) => {
  const filteredWithImgs = [...collageData].filter((arrEl) => arrEl.event === eventType && arrEl.imagePath.length );
  const filteredWithNoImgs = [...collageData].filter((arrEl) => arrEl.event === eventType && arrEl.imagePath.length === 0 ).slice(0, (10 - filteredWithImgs.length));

  return [...filteredWithImgs, ...filteredWithNoImgs];
};

/**
 * function that calculates the wishlist total, the data from DB
 * comes with a wishlist Total but it is inaccurate, hence why
 * this is here :(
 * @param  {Object} wishListItems [description]
 * @return {Number} wishlist Total Items
 */
internals.calculateWishlistTotal = (wishListItems = {}) => {
  let total = 0;

  Object.keys(wishListItems).map((event) => {
    Object.keys(wishListItems[event]).map((category) => {
      Object.keys(wishListItems[event][category]).map((subcategory) => {
        wishListItems[event][category][subcategory].forEach((el) => {
          if (el.hasOwnProperty('totalPrice') && el.totalPrice !== '' && !el.hiddenPrice) {
            total += parseInt(el.totalPrice, 10);
          }
        });
      });
    });
  });

  return total;
};

const wishlistRegion = { id: 0, name: ''};
const wishlistInfo = $.extend(true, {}, beaches_app.page.wishlistData.wishListDetails);
const wishlistDetail = $.extend(true, {}, beaches_app.page.wishlistData.wishListItems);
const wishlistUser = $.extend(true, {}, beaches_app.page.wishlistUser);
const countries = $.extend(true, [], beaches_app.page.countries);

wishlistRegion.id = wishlistInfo.regionId;
wishlistRegion.name = (beaches_app.page.wishlistData.regionName) ? beaches_app.page.wishlistData.regionName.replace(/[\s-]+/g, '') : '';

delete wishlistUser.country;
delete wishlistUser.lastName;
delete wishlistUser.optedIn;
wishlistUser.wishlistCount = beaches_app.page.wishlistCount;

const filteredCollageData = {};

filteredCollageData.receptionCollageData = internals.filterCollageDataByEvent(beaches_app.page.wishlistCollageData, 'RECEPTION');
filteredCollageData.ceremonyCollageData = internals.filterCollageDataByEvent(beaches_app.page.wishlistCollageData, 'CEREMONY');

const wishlistTotal = internals.calculateWishlistTotal(beaches_app.page.wishlistData.wishListItems);

wishlistInfo.total = wishlistTotal;

ReactDOM.render(
  <MainPanel
    wishlistInfo={ wishlistInfo }
    wishlistDetailData={ wishlistDetail }
    wishlistRegion={ wishlistRegion }
    wishlistUser={ wishlistUser }
    countries={ countries }
    calculateWishlistTotal = { internals.calculateWishlistTotal }
    {...filteredCollageData}
  />,
  $('#root').get(0)
);
